/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbClauseGridDto } from './FcbClauseGridDto';
import {
    FcbClauseGridDtoFromJSON,
    FcbClauseGridDtoFromJSONTyped,
    FcbClauseGridDtoToJSON,
} from './FcbClauseGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbClauseGridDtoPaginatedResults
 */
export interface FcbClauseGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbClauseGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbClauseGridDto>}
     * @memberof FcbClauseGridDtoPaginatedResults
     */
    results?: Array<FcbClauseGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbClauseGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbClauseGridDtoPaginatedResults interface.
 */
export function instanceOfFcbClauseGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbClauseGridDtoPaginatedResultsFromJSON(json: any): FcbClauseGridDtoPaginatedResults {
    return FcbClauseGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbClauseGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbClauseGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbClauseGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbClauseGridDtoPaginatedResultsToJSON(value?: FcbClauseGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbClauseGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

